<template>
  <div>
    <v-btn
      color="primary"
      fab
      small
      :disabled="!listView"
      @click="listView = false"
    >
      <v-icon small>
        fas fa-th
      </v-icon>
    </v-btn>
    <v-btn
      color="primary"
      fab
      small
      :disabled="listView"
      class="ml-3"
      @click="listView = true"
    >
      <v-icon small>
        fas fa-list
      </v-icon>
    </v-btn>
  </div>
</template>
<script>
  export default {
    name: 'ViewSelector',
    computed: {
      listView: {
        get () {
          return this.$store.state.listView
        },
        set (bool) {
          // this.$vuetify.goTo(0)
          this.$store.commit('SET_LIST_VIEW', bool)
        },
      },
    },
  }
</script>
